import React from 'react';
import { Lock, Download, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-section" className="bg-white py-24 px-4" data-id="element-135">
      <div className="max-w-[720px] mx-auto" data-id="element-136">
        <FadeIn data-id="element-137">
          <div className="text-center mb-10" data-id="element-138">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-139">
              Recupera el control de tu cuerpo hoy mismo
            </h2>
            <p className="text-lg text-[#5A5A5A]" data-id="element-140">
              No esperes a que tu inflamación se convierta en un problema mayor.
              Obtén el Protocolo Anti-Inflamatorio 72h completo por una fracción
              de lo que cuesta una consulta nutricional.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-141">
          <div className="bg-[#FDFAF5] rounded-3xl p-8 md:p-12 border-2 border-[#2D5A27] shadow-2xl relative" data-id="element-142">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#2D5A27] text-white px-6 py-2 rounded-full font-bold text-sm tracking-wide uppercase" data-id="element-143">
              Acceso Inmediato
            </div>

            <div className="text-center mb-8 mt-4" data-id="element-144">
              <p className="text-[#5A5A5A] font-medium mb-2" data-id="element-145">Inversión única</p>
              <div className="flex items-center justify-center" data-id="element-146">
                <span className="text-xl text-gray-400 line-through font-medium" data-id="element-147">
                  $27 USD
                </span>
              </div>
              <div className="mt-3 flex items-center justify-center gap-3" data-id="element-148">
                <span className="text-5xl md:text-6xl font-extrabold text-[#2D5A27]" data-id="element-149">
                  $6.36{' '}
                  <span className="text-2xl text-[#5A5A5A] font-medium" data-id="element-150">
                    USD
                  </span>
                </span>
              </div>
              <div className="mt-3 inline-block bg-red-50 border border-red-200 text-red-600 text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-151">
                🔥 93% de descuento — Oferta por tiempo limitado
              </div>
            </div>

            <ul className="space-y-4 mb-10 max-w-md mx-auto" data-id="element-152">
              {['Manual Maestro 72h (PDF)', 'Semáforo de Alimentos Reactivos', 'Secuencia de Movimiento Linfático', 'Lista de Compras Zero-Inflam', 'Diario de Reacción Personal', 'Guía de Emergencia 24h'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-153">
                  <CheckCircle className="w-5 h-5 text-[#4A7C42] flex-shrink-0" data-id="element-154" />
                  <span className="text-[#1A1A1A] font-medium" data-id="element-155">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col items-center" data-id="element-156">
              <Button href="https://vivoligero.com/cart/46771218022540:1" className="w-full md:w-auto px-10 py-5 text-lg" icon={<Download className="w-6 h-6" data-id="element-158" />} onClick={() => trackAddToCart()} data-id="element-157">
                SÍ, QUIERO DESINFLAMARME AHORA
              </Button>
              <p className="text-center text-[#5A5A5A] mt-4 text-sm font-medium" data-id="element-159">
                Descarga el protocolo al instante y comienza tu transformación
                de 3 días.
              </p>

              <div className="flex items-center justify-center gap-2 mt-6 text-xs text-gray-400 font-medium" data-id="element-160">
                <Lock className="w-4 h-4" data-id="element-161" />
                <span data-id="element-162">Pago 100% Seguro y Encriptado</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}